import axios from 'axios';

export default {
  
  downloadQuickbooksExtractCreditNotesCSV (filters, filename) {
    let url = process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/credit-notes/reports/QUICKBOOKS_EXPORT";
    let params  = filters;
    return axios({
          url: url,
          method: 'GET',
          params,
          responseType: 'blob', // important
        }).then((response) => {
           const url = window.URL.createObjectURL(new Blob(['\uFEFF', response.data], { type: 'text/csv; charset=utf-8' }));
           const link = document.createElement('a');
           link.href = url;
           // console.log(response);
           link.setAttribute('download', filename+'.csv'); //or any other extension
           document.body.appendChild(link);
           link.click();
        });
  },
  create(creditNoteToCreate){
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/credit-notes",creditNoteToCreate)
      .then(results=>{
        return results.data;
      })
  },
  reOpen(creditNoteId, refund){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/credit-notes/"+creditNoteId+"/reOpen",refund)
      .then(results=>{
        return results.data;
      })
  },
  refund(creditNoteId, refund){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/credit-notes/"+creditNoteId+"/refund",refund)
      .then(results=>{
        return results.data;
      })
  },
  sendCreditNoteNotification(id, contacts, content, language, attachment) {
    let data = {};
    data.contacts = contacts
    data.content = content;
    data.language=language;
    data.attachment=attachment;
    return axios.post(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/credit-notes/"+id+"/email", data)
      .then(results=>{
        return results.data;
      })
  },
  previewCreditNoteNotification(creditNoteId, params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/credit-notes/"+creditNoteId+"/email", {params})
      .then(results=>{
        return results.data;
      })
  },
  void(creditNoteId){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/credit-notes/"+creditNoteId+"/void")
      .then(results=>{
        return results.data;
      })
  },
  reOPen(creditNoteId){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/credit-notes/"+creditNoteId+"/reOpen")
      .then(results=>{
        return results.data;
      })
  },
  put(creditNoteToUpdate){
    return axios.put(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/credit-notes/"+creditNoteToUpdate.id,creditNoteToUpdate)
      .then(results=>{
        return results.data;
      })
  },
  fetchAdminCreditNotes(params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/credit-notes",{params})
      .then(results=>{
        return results.data;
      })
  },
  // Deprecated
  fetchCreditNotes(params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/credit-notes",{params})
      .then(results=>{
        return results.data;
      })
  },
  fetchCreditNotesV2(params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/credit-notes",{params})
      .then(results=>{
        return results.data;
      })
  },
  getCreditNotes(creditNoteId){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/credit-notes/"+creditNoteId)
      .then(results=>{
        return results.data;
      })
  },
  delete(creditNoteId){
    return axios.delete(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/credit-notes/"+creditNoteId)
      .then(results=>{
        return results.data;
      })
  },
  downloadInvoiceReport(creditNoteId, filename){
    let url = process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/credit-notes/"+creditNoteId+"/report";

    return axios({
          url: url,
          method: 'GET',
          responseType: 'blob', // important
        }).then((response) => {
           const url = window.URL.createObjectURL(new Blob([response.data]));
           const link = document.createElement('a');
           link.href = url;
           // console.log(response);
           link.setAttribute('download', filename+'.pdf'); //or any other extension
           document.body.appendChild(link);
           link.click();
        });
  },
  downloadCreditsReport(reportCode, filename, params){
    params.format = 'CSV';
    let url = process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/credit-notes";

    // console.log("downloadSalesOrderReport : ", filename);

    return axios({
          url: url,
          method: 'GET',
          params,
          responseType: 'blob', // important
        }).then((response) => {
           const url = window.URL.createObjectURL(new Blob(['\uFEFF', response.data], { type: 'text/csv; charset=utf-8' }));
           const link = document.createElement('a');
           link.href = url;
           // console.log(response);
           link.setAttribute('download', filename); //or any other extension
           document.body.appendChild(link);
           link.click();
        });
  },

}
